import { Navigate, createBrowserRouter } from "react-router-dom";

/**ADMIN ROUTE START */
import AdminLayout from "./modules/admin/shared/adminlayout";
import Login from "./modules/admin/pages/login";
import PrivateRoute from "./modules/admin/shared/privateRoute";
import PublicRoute from "./modules/admin/shared/publicRoute";
import Profile from "./modules/admin/pages/profile";
import EditProfile from "./modules/admin/pages/editprofile";
import Changepassword from "./modules/admin/pages/changepassword";
import OtpVerificationPage from "./modules/admin/pages/otpverification";
import ForgotPwdPage from "./modules/admin/pages/forgotpassword";
import ResetPwdPage from "./modules/admin/pages/resetpwd";
import Error404 from "./modules/admin/pages/404";
import Dashboard from "./modules/admin/pages/dashboard";
import EmailTemplatesTable from "./modules/admin/pages/cms/automaticemailtemplates/list";
import EmailTempAdd from "./modules/admin/pages/cms/automaticemailtemplates/add";
import EmailTempEdit from "./modules/admin/pages/cms/automaticemailtemplates/edit";
import ViewEmailTemp from "./modules/admin/pages/cms/automaticemailtemplates/view";
import PageTable from "./modules/admin/pages/cms/pages/list";
import PageAdd from "./modules/admin/pages/cms/pages/add";
import PageEdit from "./modules/admin/pages/cms/pages/edit";
import PageView from "./modules/admin/pages/cms/pages/view";
import GlobalSettings from "./modules/admin/pages/cms/settings/settings";

import CompleteAdminProfile from "./modules/admin/pages/completeAdminProfile";

import InvoiceDesign from "./modules/admin/pages/invoiceDesign";
import AdminUnAuthLayout from "./modules/admin/shared/adminUnAuthLayout";
import WebsiteLayout from "./modules/website/shared/layout";
import WebsiteHomePage from "./modules/website/pages/homePage";
import WebsiteAboutUs from "./modules/website/pages/websiteAboutUs";
import WebsiteContactUs from "./modules/website/pages/websiteContactUs";
import WebsiteServices from "./modules/website/pages/websiteServices";
import WebsitePrivacyPolicy from "./modules/website/pages/privacyPolicy";
import WebsiteTermsCondition from "./modules/website/pages/termsCondition";
import Faq from "./modules/website/pages/Faq";
import Page404 from "./modules/website/pages/Page404";
import FAQAdd from "./modules/admin/pages/cms/faq/add";
import FAQEdit from "./modules/admin/pages/cms/faq/edit";
import FAQTable from "./modules/admin/pages/cms/faq/list";
import FAQView from "./modules/admin/pages/cms/faq/view";
import ContactUsTable from "./modules/admin/pages/contactUs/list";
import ViewContactUs from "./modules/admin/pages/contactUs/view";
import PsychicLayout from "./modules/psychic/shared/layout";
import PsychicLogin from "./modules/psychic/pages/PsychicLogin";
import PsychicDashboardLayout from "./modules/psychic/pages/Dahshboard/shared/PsychicDashboardLayout";
import PsychicDashboard from "./modules/psychic/pages/Dahshboard/pages/PsychicDashboard";
import MyCalendar from "./modules/psychic/pages/Dahshboard/pages/MyCalendar";
import MyEarnings from "./modules/psychic/pages/Dahshboard/pages/MyEarnings";
import Chat from "./modules/psychic/pages/Dahshboard/pages/Chat";
import MyBookings from "./modules/psychic/pages/Dahshboard/pages/MyBookings";
import PsychicProfile from "./modules/psychic/pages/PsychicProfile";
import ChangePassword from "./modules/psychic/pages/ChangePassword";
import CustomerFeedback from "./modules/psychic/pages/CustomerFeedback";
import PaymentHistory from "./modules/psychic/pages/Dahshboard/pages/PaymentHistory";
import Notification from "./modules/psychic/pages/Notification";
import InquiryTable from "./modules/admin/pages/inquiry/list";
import ViewInquiry from "./modules/admin/pages/inquiry/view";
import WebsiteInquiry from "./modules/website/pages/websiteInquiry";
import PsychicPrivateRoute from "./modules/psychic/shared/PsychicPrivateRoute";
import QuestionAdd from "./modules/admin/pages/cms/questionSet/add";
import QuestionTable from "./modules/admin/pages/cms/questionSet/list";
import QuestionView from "./modules/admin/pages/cms/questionSet/view";
import QuestionEdit from "./modules/admin/pages/cms/questionSet/edit";
import PsychicPublicRoute from "./modules/psychic/shared/PsychicPublicRoute";
import ForgetPasswordPsychic from "./modules/psychic/pages/auth/forgetPassword";
import PsychicAuthLayout from "./modules/psychic/shared/PsychicAuthLayout";
import PsychicVerifyOtp from "./modules/psychic/pages/auth/OtpVarifivation";
import PsychicResetPassword from "./modules/psychic/pages/auth/PsychicResetPassword";
import UserTable from "./modules/admin/pages/user/list";
import UserView from "./modules/admin/pages/user/view";
import DynamicWebPage from "./modules/website/pages/dynamicPage";
import UserEdit from "./modules/admin/pages/user/edit";
import AboutUsAdd from "./modules/admin/pages/cms/aboutUs/add";
import Feedback from "./modules/psychic/pages/Dahshboard/pages/Feedback";
import NotificationPage from "./modules/psychic/pages/Notification";
import SubscriptionPlanTable from "./modules/admin/pages/subscriptionPlan/list";
import AddSubscriptionPlan from "./modules/admin/pages/subscriptionPlan/add";
import EditSubscriptionPlan from "./modules/admin/pages/subscriptionPlan/edit";
import SubscriptionPlanView from "./modules/admin/pages/subscriptionPlan/view";
import MyCalendarTest from "./modules/psychic/pages/Dahshboard/pages/MyCalendarPrev";
import ServiceTable from "./modules/admin/pages/cms/services/list";
import ServiceAdd from "./modules/admin/pages/cms/services/add";
import ServiceEdit from "./modules/admin/pages/cms/services/edit";
import ServiceView from "./modules/admin/pages/cms/services/view";
import WebsiteHomeAdd from "./modules/admin/pages/cms/home/add";
import MyBookingView from "./modules/psychic/pages/Dahshboard/pages/MyBookingView";
import AstrologerUserTable from "./modules/admin/pages/astrologer/list";
import AstrologerView from "./modules/admin/pages/astrologer/view";
import AstrologerAdd from "./modules/admin/pages/astrologer/add";
import AstrologerEdit from "./modules/admin/pages/astrologer/edit";
import AIAstrologerUserTable from "./modules/admin/pages/ai-astrologer/list";
import AIAstrologerView from "./modules/admin/pages/ai-astrologer/view";
import AIAstrologerAdd from "./modules/admin/pages/ai-astrologer/add";
import AIAstrologerEdit from "./modules/admin/pages/ai-astrologer/edit";
import UserPrivateRoute from "./modules/user/shared/UserPrivateRoute";
import UserLayout from "./modules/user/shared/layout";
import UserHomeFront from "./modules/user";
import UserHomePage from "./modules/user/pages/components/home";
import UserDashboard from "./modules/user/pages/components/dashboardSidebar";
import UserPublicRoute from "./modules/user/shared/UserPublicRoute";
import UserAuthLayout from "./modules/user/shared/UserAuthLayout";
import UserLogin from "./modules/user/pages/auth/UserLogin";
import ForgetPassword from "./modules/user/pages/auth/ForgetPassword";
import UserFrontLayout from "./modules/user/shared/UserFrontLayout";
import ResetPassword from "./modules/user/pages/auth/ResetPassword";
import UserSignUp from "./modules/user/pages/auth/UserSignUp";
import ProfileSetup from "./modules/user/pages/auth/ProfileSetup";
import UserDashborad from "./modules/user/pages/dashborad/dashborad";
import Search from "./modules/user/pages/dashborad/search";
import Notifications from "./modules/user/pages/dashborad/notifications";
import Horoscope from "./modules/user/pages/dashborad/horoscope";
import Numerology from "./modules/user/pages/dashborad/numerology";
import KundliMatching from "./modules/user/pages/dashborad/kundliMatching";
import ChatInterface from "./modules/admin/pages/chat/ChatInterface";
import SupportChatInterface from "./modules/admin/pages/supportChat/SupportChatInterface";

import KundliMatchingDetail from "./modules/user/pages/dashborad/kundliMatching/Detail";
import MyKundli from "./modules/user/pages/dashborad/MyKundli";
import UserAdd from "./modules/admin/pages/user/add";
import AddRemedy from "./modules/admin/pages/remedies/AddRemedy";
import RemedyList from "./modules/admin/pages/remedies/RemedyList";
import EditRemedy from "./modules/admin/pages/remedies/EditRemedy";
import ViewRemedy from "./modules/admin/pages/remedies/ViewRemedy";
import FeedbackTable from "./modules/admin/pages/feedback/list";
import FeedbackView from "./modules/admin/pages/feedback/view";
import BookingTable from "./modules/admin/pages/booking/list";
import ConsultationHistoryView from "./modules/admin/pages/booking/view";
import ConsultationRescheduleList from "./modules/admin/pages/booking/ConsultationRescheduleList";
import OfferManagementAdd from "./modules/admin/pages/cms/offerManagement/ OfferManagementAdd";
import LiveConsultationMonitor from "./modules/admin/pages/LiveConsultation/LiveConsultationMonitor";
import CallLogsPage from "./modules/admin/pages/astrologer/CallLogsPage";
import RevenueDashboard from "./modules/admin/pages/dashboard/RevenueDashboard";
import ListLearnHub from "./modules/admin/pages/cms/learn-hub/list";
import AddLearnHub from "./modules/admin/pages/cms/learn-hub/add";
import EditLearnHub from "./modules/admin/pages/cms/learn-hub/edit";
import ViewLearnHub from "./modules/admin/pages/cms/learn-hub/view";
import WithdrawalList from "./modules/admin/pages/withdrawal/WithdrawalList";
import ManualWithdrawalList from "./modules/admin/pages/withdrawal/ManualWithdrawalList";
import ManualWithdrawalHistory from "./modules/admin/pages/withdrawal/ManualWithdrawalHistory";
import PujaBookingsList from "./modules/admin/pages/pujaBooking/PujaBookingsList";
import PujaBookingsList1 from "./modules/admin/pages/pujaBooking/PujaBookingsList1";
import PujaBookingView from "./modules/admin/pages/pujaBooking/PujaBookingView";
import ReschedulePujaList from "./modules/admin/pages/pujaBooking/ReschedulePujaList";
import OrderList from "./modules/admin/pages/order/OrderList";
import OrderView from "./modules/admin/pages/order/OrderView";
import ReportsAnalytics from "./modules/admin/pages/dashboard/ReportsAnalytics";
import AdminEmailAnnouncement from "./modules/admin/pages/cms/Announcement/AdminSendAnnouncement";
import AdminNotificationAnnouncement from "./modules/admin/pages/cms/Announcement/AdminNotificationAnnouncement";
import BannerTable from "./modules/admin/pages/cms/banner/list";
import BannerAdd from "./modules/admin/pages/cms/banner/add";
import BannerEdit from "./modules/admin/pages/cms/banner/edit";
import BannerView from "./modules/admin/pages/cms/banner/view";
import PackageTable from "./modules/admin/pages/package/list";
import AddPackage from "./modules/admin/pages/package/add";
import EditPackage from "./modules/admin/pages/package/edit";
import PujaCategoryTable from "./modules/admin/pages/pujaCategory/list";
import AddPujaCategory from "./modules/admin/pages/pujaCategory/add";
import EditPujaCategory from "./modules/admin/pages/pujaCategory/edit";
import PujaTypeTable from "./modules/admin/pages/pujaType/list";
import AddPujaType from "./modules/admin/pages/pujaType/add";
import EditPujaType from "./modules/admin/pages/pujaType/edit";
import PujaTable from "./modules/admin/pages/puja/list";
import AddPuja from "./modules/admin/pages/puja/add";
import EditPuja from "./modules/admin/pages/puja/edit";
import PujaView from "./modules/admin/pages/puja/view";
import ProductCategoryTable from "./modules/admin/pages/productCategory/list";
import AddProductCategory from "./modules/admin/pages/productCategory/add";
import EditProductCategory from "./modules/admin/pages/productCategory/edit";
import ProductAttributeTable from "./modules/admin/pages/productAttribute/list";
import AddProductAttribute from "./modules/admin/pages/productAttribute/add";
import EditProductAttribute from "./modules/admin/pages/productAttribute/edit";
import AttributeValueTable from "./modules/admin/pages/productAttributeValue/list";
import AddAttributeValue from "./modules/admin/pages/productAttributeValue/add";
import EditAttributeValue from "./modules/admin/pages/productAttributeValue/edit";
import ProductTable from "./modules/admin/pages/product/list";
import AddProduct from "./modules/admin/pages/product/add";
import EditProduct from "./modules/admin/pages/product/edit";
import ProductView from "./modules/admin/pages/product/view";
import VideoTable from "./modules/admin/pages/video/list";
import AddVideo from "./modules/admin/pages/video/add";
import EditVideo from "./modules/admin/pages/video/edit";
import ViewVideo from "./modules/admin/pages/video/view";
import PaymentSummary from "./modules/admin/pages/paymentManagement/PaymentSummary";
import WalletHistory from "./modules/admin/pages/paymentManagement/WalletHistory";
import GatewayPayments from "./modules/admin/pages/paymentManagement/GatewayPayments";
import OrderPayments from "./modules/admin/pages/paymentManagement/OrderPayments";
import ConsultationPayments from "./modules/admin/pages/paymentManagement/ConsultationPayments";
import TransactionView from "./modules/admin/pages/paymentManagement/TransactionView";
import TransactionList from "./modules/admin/pages/transaction/list";
import ReportTable from "./modules/admin/pages/report/list";
import AddReport from "./modules/admin/pages/report/add";
import EditReport from "./modules/admin/pages/report/edit";
import ViewReport from "./modules/admin/pages/report/view";
import PersonalizedReportList from "./modules/admin/pages/report/bookingList";
import ViewReportBooking from "./modules/admin/pages/report/viewBooking";
import ReportPriceTable from "./modules/admin/pages/reportPrice/list";
import AddReportPrice from "./modules/admin/pages/reportPrice/add";
import EditReportPrice from "./modules/admin/pages/reportPrice/edit";
import QuestionBookingList from "./modules/admin/pages/report/questionBookingList";
import ViewQuestionBooking from "./modules/admin/pages/report/viewQuestionBooking";
import RatingList from "./modules/admin/pages/rating/list";
import VerificationList from "./modules/admin/pages/verification/list";
import ProductRatingList from "./modules/admin/pages/productRating/list";
import NotificationTable from "./modules/admin/pages/notification/list";
import SendNotification from "./modules/admin/pages/notification/send";
import ViewNotification from "./modules/admin/pages/notification/view";
import EditNotification from "./modules/admin/pages/notification/edit";

import AppMenuCategoryTable from "./modules/admin/pages/appMenuCategory/list";
import AddAppMenuCategory from "./modules/admin/pages/appMenuCategory/add";
import EditAppMenuCategory from "./modules/admin/pages/appMenuCategory/edit";

import AppMenuItemTable from "./modules/admin/pages/appMenuItem/list";
import AddAppMenuItem from "./modules/admin/pages/appMenuItem/add";
import EditAppMenuItem from "./modules/admin/pages/appMenuItem/edit";
import AppLogin from "./modules/auth/AppLogin";

const router = createBrowserRouter([
  {
    path: "",
    element: <Navigate to={"/admin/dashboard"} />,
  },
  { path: "app-login", element: <AppLogin /> },
  { path: "web-login", element: <AppLogin /> },
  { path: "org-info/:slug", element: <DynamicWebPage /> },

  //  user auth start
  {
    path: "",
    element: <UserPublicRoute component={UserAuthLayout} />,
    children: [
      {
        path: "login",
        element: <UserPublicRoute component={UserLogin} />,
      },
      {
        path: "forget-password",
        element: <UserPublicRoute component={ForgetPassword} />,
      },
      {
        path: "reset-password",
        element: <UserPublicRoute component={ResetPassword} />,
      },
      {
        path: "sign-up",
        element: <UserPublicRoute component={UserSignUp} />,
      },
      {
        path: "profile-setup",
        element: <UserPublicRoute component={ProfileSetup} />,
      },
    ],
  },

  // after login
  {
    path: "user",
    element: <UserPrivateRoute component={UserLayout} />,
    children: [
      {
        path: "",
        element: <UserPrivateRoute component={UserDashborad} />,
      },
      {
        path: "search",
        element: <UserPrivateRoute component={Search} />,
      },
      {
        path: "notifications",
        element: <UserPrivateRoute component={Notifications} />,
      },
      {
        path: "horoscope",
        element: <UserPrivateRoute component={Horoscope} />,
      },
      {
        path: "numerology",
        element: <UserPrivateRoute component={Numerology} />,
      },
      {
        path: "kundli-matching",
        element: <UserPrivateRoute component={KundliMatching} />,
      },
      {
        path: "kundli-matching-detail",
        element: <UserPrivateRoute component={KundliMatchingDetail} />,
      },
      {
        path: "my-kundli",
        element: <UserPrivateRoute component={MyKundli} />,
      },

      { path: "*", element: <Page404 /> },
    ],
  },

  /** user auth end */

  /** PSYCHIC / ASTROLOGER ROUTE START */
  {
    path: "psychic",
    element: <PsychicPrivateRoute component={PsychicDashboardLayout} />,
    children: [
      {
        path: "",
        element: <Navigate to="/psychic/dashboard" replace />,
      },
      {
        path: "dashboard",
        element: <PsychicPrivateRoute component={PsychicDashboard} />,
      },
      {
        path: "my-bookings",
        element: <PsychicPrivateRoute component={MyBookings} />,
      },
      {
        path: "my-booking-view/:id",
        element: <PsychicPrivateRoute component={MyBookingView} />,
      },
      {
        path: "my-calendar",
        element: <PsychicPrivateRoute component={MyCalendar} />,
      },
      {
        path: "my-earnings",
        element: <PsychicPrivateRoute component={MyEarnings} />,
      },
      {
        path: "chat",
        element: <PsychicPrivateRoute component={Chat} />,
      },
      {
        path: "profile",
        element: <PsychicPrivateRoute component={PsychicProfile} />,
      },
      {
        path: "change-password",
        element: <PsychicPrivateRoute component={ChangePassword} />,
      },
      {
        path: "customer-feedback",
        element: <PsychicPrivateRoute component={CustomerFeedback} />,
      },
      {
        path: "payment-history",
        element: <PsychicPrivateRoute component={PaymentHistory} />,
      },
      {
        path: "notification",
        element: <PsychicPrivateRoute component={NotificationPage} />,
      },
    ],
  },
  {
    path: "psychic/login",
    element: <PsychicPublicRoute component={PsychicLogin} />,
  },
  {
    path: "psychic/forget-password",
    element: <PsychicPublicRoute component={ForgetPasswordPsychic} />,
  },
  {
    path: "psychic/otp-verification",
    element: <PsychicPublicRoute component={PsychicVerifyOtp} />,
  },
  {
    path: "psychic/reset-password",
    element: <PsychicPublicRoute component={PsychicResetPassword} />,
  },
  {
    path: "live/host",
    element: <PsychicPrivateRoute component={PsychicDashboardLayout} />,
    children: [
      {
        path: "",
        element: <PsychicPrivateRoute component={MyBookingView} />,
      },
    ],
  },

  /**ADMIN ROUTE START */
  {
    path: "admin",
    element: <PrivateRoute component={AdminLayout} />,
    children: [
      {
        path: "",
        element: <Navigate to={"/admin/dashboard"} />,
      },
      {
        path: "live-consultation-monitor",
        element: <PrivateRoute component={LiveConsultationMonitor} />,
      },
      {
        path: "dashboard",
        element: <PrivateRoute component={Dashboard} />,
      },
      {
        path: "revenue",
        element: <PrivateRoute component={RevenueDashboard} />,
      },
      {
        path: "analytics-reports",
        element: <PrivateRoute component={ReportsAnalytics} />,
      },
      {
        path: "invoice-design",
        element: <PrivateRoute component={InvoiceDesign} />,
      },
      {
        path: "profile",
        element: <PrivateRoute component={Profile} />,
        children: [
          {
            path: "edit/:id",
            element: <PrivateRoute component={EditProfile} />,
          },
          {
            path: "change-password/:id",
            element: <PrivateRoute component={Changepassword} />,
          },
        ],
      },
      {
        /** astrologer User management route start */
      },
      {
        path: "astrologer-management/astrologer/list/:pgno",
        element: <AstrologerUserTable />,
      },
      {
        path: "astrologer-management/astrologer/view/:id",
        element: <AstrologerView />,
      },
      {
        path: "astrologer-management/astrologer/add",
        element: <AstrologerAdd />,
      },
      {
        path: "astrologer-management/astrologer/:pgno/edit/:id",
        element: <AstrologerEdit />,
      },
      {
        path: "astrologer-management/astrologer/call-logs/:id/:pgno",
        element: <CallLogsPage />,
      },
      {
        /** astrologer User management route end */
      },

      {
        /** ai astrologer User management route start */
      },
      {
        path: "astrologer-management/ai-astrologer/list/:pgno",
        element: <AIAstrologerUserTable />,
      },
      {
        path: "astrologer-management/ai-astrologer/view/:id",
        element: <AIAstrologerView />,
      },
      {
        path: "astrologer-management/ai-astrologer/add",
        element: <AIAstrologerAdd />,
      },
      {
        path: "astrologer-management/ai-astrologer/:pgno/edit/:id",
        element: <AIAstrologerEdit />,
      },
      {
        /** ai astrologer User management route end */
      },

      {
        /**  User management route start */
      },
      {
        path: "user-management/user/list/:pgno",
        element: <UserTable />,
      },
      {
        path: "user-management/user/view/:id",
        element: <UserView />,
      },
      {
        path: "user-management/user/:pgno/edit/:id",
        element: <UserEdit />,
      },
      {
        path: "user-management/user/add",
        element: <UserAdd />,
      },
      {
        /** User management route end */
      },

      {
        /**contact-us route start */
      },
      {
        path: "contact-us/list/:pgno",
        element: <PrivateRoute component={ContactUsTable} />,
      },
      {
        path: "contact-us/view/:id",
        element: <PrivateRoute component={ViewContactUs} />,
      },
      {
        /**contact-us route end */
      },

      /* remedies management route start */
      {
        path: "remedies-management/remedies/list/:pgno",
        element: <PrivateRoute component={RemedyList} />,
      },
      {
        path: "remedies-management/remedies/view/:id",
        element: <PrivateRoute component={ViewRemedy} />,
      },
      {
        path: "remedies-management/remedies/add",
        element: <PrivateRoute component={AddRemedy} />,
      },
      {
        path: "remedies-management/remedies/edit/:id",
        element: <PrivateRoute component={EditRemedy} />,
      },
      /* remedies management route end */

      /* feedback management route start */
      {
        path: "feedback/list/:pgno",
        element: <PrivateRoute component={FeedbackTable} />,
      },
      {
        path: "feedback/view/:id",
        element: <PrivateRoute component={FeedbackView} />,
      },
      /* feedback management route end */

      /* booking management route start */
      {
        path: "consultation/list/:pgno",
        element: <PrivateRoute component={BookingTable} />,
      },
      {
        path: "consultation/view/:id",
        element: <PrivateRoute component={ConsultationHistoryView} />,
      },
      {
        path: "consultation/reschedules",
        element: <PrivateRoute component={ConsultationRescheduleList} />,
      },
      /* booking management route end */

      {
        path: "cms/services/list/:pgno",
        element: <PrivateRoute component={ServiceTable} />,
      },
      {
        path: "cms/service-offer/add",
        element: <PrivateRoute component={OfferManagementAdd} />,
      },

      // Inquiry

      {
        path: "inquiry/list/:pgno",
        element: <PrivateRoute component={InquiryTable} />,
      },
      {
        path: "inquiry/view/:id",
        element: <PrivateRoute component={ViewInquiry} />,
      },

      // Inquiry

      // Learn hub section start
      {
        path: "cms/learn-hub/list/:pgno",
        element: (
          <PrivateRoute component={ListLearnHub} requiredPermission="video" />
        ),
      },
      {
        path: "cms/learn-hub/add",
        element: (
          <PrivateRoute component={AddLearnHub} requiredPermission="video" />
        ),
      },
      {
        path: "cms/learn-hub/:pgno/edit/:id",
        element: (
          <PrivateRoute component={EditLearnHub} requiredPermission="video" />
        ),
      },
      {
        path: "cms/learn-hub/view/:id",
        element: (
          <PrivateRoute component={ViewLearnHub} requiredPermission="video" />
        ),
      },
      // Learn hub section end

      // Pages start

      {
        path: "cms/pages/list/:pgno",
        element: <PrivateRoute component={PageTable} />,
      },
      {
        path: "cms/pages/add",
        element: <PrivateRoute component={PageAdd} />,
      },
      {
        path: "cms/pages/:pgno/edit/:id",
        element: <PrivateRoute component={PageEdit} />,
      },
      {
        path: "cms/pages/view/:id",
        element: <PrivateRoute component={PageView} />,
      },

      // Services

      {
        path: "cms/services/list/:pgno",
        element: <PrivateRoute component={ServiceTable} />,
      },
      {
        path: "cms/services/add",
        element: <PrivateRoute component={ServiceAdd} />,
      },
      {
        path: "cms/services/:pgno/edit/:id",
        element: <PrivateRoute component={ServiceEdit} />,
      },
      {
        path: "cms/services/view/:id",
        element: <PrivateRoute component={ServiceView} />,
      },

      // About Us

      {
        path: "cms/about-us",
        element: <PrivateRoute component={AboutUsAdd} />,
      },
      //   path: "cms/question/:pgno/edit/:id",
      //   path: "cms/question/view/:id",

      // cms home

      {
        path: "cms/web-home",
        element: <PrivateRoute component={WebsiteHomeAdd} />,
      },

      // FAQ

      {
        path: "cms/faq/list/:pgno",
        element: <PrivateRoute component={FAQTable} />,
      },
      {
        path: "cms/faq/add",
        element: <PrivateRoute component={FAQAdd} />,
      },
      {
        path: "cms/faq/:pgno/edit/:id",
        element: <PrivateRoute component={FAQEdit} />,
      },
      {
        path: "cms/faq/view/:id",
        element: <PrivateRoute component={FAQView} />,
      },

      {
        path: "cms/settings",
        element: <PrivateRoute component={GlobalSettings} />,
      },

      {
        path: "cms/default-email-template/list/:pgno",
        element: <PrivateRoute component={EmailTemplatesTable} />,
      },
      {
        path: "cms/default-email-template/add",
        element: <PrivateRoute component={EmailTempAdd} />,
      },
      {
        path: "cms/default-email-template/:pgno/edit/:id",
        element: <PrivateRoute component={EmailTempEdit} />,
      },
      {
        path: "cms/default-email-template/view/:id",
        element: <PrivateRoute component={ViewEmailTemp} />,
      },

      /** Email Logs Routing End*/
      {
        path: "cms/banner/list/:pgno",
        element: <PrivateRoute component={BannerTable} />,
      },
      {
        path: "cms/banner/add",
        element: <PrivateRoute component={BannerAdd} />,
      },
      {
        path: "cms/banner/:pgno/edit/:id",
        element: <PrivateRoute component={BannerEdit} />,
      },
      {
        path: "cms/banner/view/:id",
        element: <PrivateRoute component={BannerView} />,
      },
      {
        path: "cms/email-announcement",
        element: <PrivateRoute component={AdminEmailAnnouncement} />,
      },
      {
        path: "cms/notification-announcement",
        element: <PrivateRoute component={AdminNotificationAnnouncement} />,
      },

      // withdrawal management start

      { path: "withdrawal/list/:pgno", element: <WithdrawalList /> },
      { path: "withdrawal/manual-list", element: <ManualWithdrawalList /> },
      { path: "withdrawal/manual-history", element: <ManualWithdrawalHistory /> },

      // withdrawal management end

      // order management start

      { path: "order/list/:pgno", element: <OrderList /> },

      { path: "order/view/:id", element: <OrderView /> },

      // order management end

      // puja booking management start

      { path: "puja-booking/list/:pgno", element: <PujaBookingsList /> },
      { path: "puja-booking/list1/:pgno", element: <PujaBookingsList1 /> },
      { path: "puja-booking/view/:id", element: <PujaBookingView /> },
      { path: "puja/reschedules", element: <ReschedulePujaList /> },

      // puja booking management end

      // transaction
      {
        path: "subscription/transaction/list/:pgno",
        element: <PrivateRoute component={TransactionList} />,
      },

      // plan
      {
        path: "subscription/subscription-plan/list/:pgno",
        element: <PrivateRoute component={SubscriptionPlanTable} />,
      },
      {
        path: "subscription/subscription-plan/add",
        element: <PrivateRoute component={AddSubscriptionPlan} />,
      },
      {
        path: "subscription/subscription-plan/edit/:id",
        element: <PrivateRoute component={EditSubscriptionPlan} />,
      },
      {
        path: "subscription/subscription-plan/view/:id",
        element: <PrivateRoute component={SubscriptionPlanView} />,
      },
      //chat interface route end
      {
        path: "chat-support",
        element: <PrivateRoute component={SupportChatInterface} />,
      },

      {
        /** package management route start */
      },
      {
        path: "package/list/:pgno",
        element: <PackageTable />,
      },
      {
        path: "package/add",
        element: <AddPackage />,
      },
      {
        path: "package/edit/:id",
        element: <EditPackage />,
      },
      {
        path: "app-menu-category/list",
        element: <Navigate to="/admin/app-menu-category/list/1" replace />,
      },
      {
        path: "app-menu-category/list/:pgno",
        element: <AppMenuCategoryTable />,
      },
      {
        path: "app-menu-category/add",
        element: <AddAppMenuCategory />,
      },
      {
        path: "app-menu-category/edit/:id",
        element: <EditAppMenuCategory />,
      },
      {
        path: "app-menu-item/list",
        element: <Navigate to="/admin/app-menu-item/list/1" replace />,
      },
      {
        path: "app-menu-item/list/:pgno",
        element: <AppMenuItemTable />,
      },
      {
        path: "app-menu-item/add",
        element: <AddAppMenuItem />,
      },
      {
        path: "app-menu-item/edit/:id",
        element: <EditAppMenuItem />,
      },
      {
        /** package management route end */
      },

      /** puja category management route start */
      {
        path: "puja-category/list/:pgno",
        element: <PrivateRoute component={PujaCategoryTable} />,
      },
      {
        path: "puja-category/add",
        element: <PrivateRoute component={AddPujaCategory} />,
      },
      {
        path: "puja-category/edit/:id",
        element: <PrivateRoute component={EditPujaCategory} />,
      },
      /** puja category management route end */

      /** product category management route start */
      {
        path: "product-category/list/:pgno",
        element: <PrivateRoute component={ProductCategoryTable} />,
      },
      {
        path: "product-category/add",
        element: <PrivateRoute component={AddProductCategory} />,
      },
      {
        path: "product-category/edit/:id",
        element: <PrivateRoute component={EditProductCategory} />,
      },
      /** product category management route end */

      /** report management route start */
      {
        path: "report/list/:pgno",
        element: <PrivateRoute component={ReportTable} />,
      },
      {
        path: "report/add",
        element: <PrivateRoute component={AddReport} />,
      },
      {
        path: "report/edit/:id",
        element: <PrivateRoute component={EditReport} />,
      },
      {
        path: "report/view/:id",
        element: <PrivateRoute component={ViewReport} />,
      },
      {
        path: "report/booking-list/:pgno",
        element: <PrivateRoute component={PersonalizedReportList} />,
      },
      {
        path: "report/booking-view",
        element: <PrivateRoute component={ViewReportBooking} />,
      },
      {
        path: "report/question-bookings/list/:pgno",
        element: <PrivateRoute component={QuestionBookingList} />,
      },
      {
        path: "report/question-bookings/view/:id",
        element: <PrivateRoute component={ViewQuestionBooking} />,
      },
      {
        path: "report-price/list",
        element: <Navigate to="/admin/report-price/list/1" replace />,
      },
      {
        path: "report-price/list/:pgno",
        element: <PrivateRoute component={ReportPriceTable} />,
      },
      {
        path: "report-price/add",
        element: <PrivateRoute component={AddReportPrice} />,
      },
      {
        path: "report-price/edit/:id",
        element: <PrivateRoute component={EditReportPrice} />,
      },
      /** report management route end */

      /** ratings management route start */
      {
        path: "rating/list",
        element: <Navigate to="/admin/rating/list/1" replace />,
      },
      {
        path: "rating/list/:pgno",
        element: <PrivateRoute component={RatingList} />,
      },
      /** ratings management route end */

      /** verification requests (past consultations and reviews) */
      {
        path: "verification/list",
        element: <PrivateRoute component={VerificationList} />,
      },

      /** product attribute management route start */
      {
        path: "product-attribute/list/:pgno",
        element: <PrivateRoute component={ProductAttributeTable} />,
      },
      {
        path: "product-attribute/add",
        element: <PrivateRoute component={AddProductAttribute} />,
      },
      {
        path: "product-attribute/edit/:id",
        element: <PrivateRoute component={EditProductAttribute} />,
      },
      /** product attribute management route end */

      /** product attribute value management route start */
      {
        path: "product-attribute-value/list/:pgno",
        element: <PrivateRoute component={AttributeValueTable} />,
      },
      {
        path: "product-attribute-value/add",
        element: <PrivateRoute component={AddAttributeValue} />,
      },
      {
        path: "product-attribute-value/edit/:id",
        element: <PrivateRoute component={EditAttributeValue} />,
      },
      /** product attribute value management route end */

      /** product management route start */
      {
        path: "product/list/:pgno",
        element: <PrivateRoute component={ProductTable} />,
      },
      {
        path: "product/add",
        element: <PrivateRoute component={AddProduct} />,
      },
      {
        path: "product/edit/:id",
        element: <PrivateRoute component={EditProduct} />,
      },
      {
        path: "product/view/:id",
        element: <PrivateRoute component={ProductView} />,
      },
      /** product management route end */

      /** product rating management route start */
      {
        path: "product-rating/list",
        element: <Navigate to="/admin/product-rating/list/1" replace />,
      },
      {
        path: "product-rating/list/:pgno",
        element: <PrivateRoute component={ProductRatingList} />,
      },
      /** product rating management route end */

      /** puja type management route start */
      // {
      //   path: "puja-type/list/:pgno",
      //   element: <PrivateRoute component={PujaTypeTable} />,
      // },
      // {
      //   path: "puja-type/add",
      //   element: <PrivateRoute component={AddPujaType} />,
      // },
      // {
      //   path: "puja-type/edit/:id",
      //   element: <PrivateRoute component={EditPujaType} />,
      // },
      /** puja type management route end */

      /** puja management route start */
      {
        path: "puja/list/:pgno",
        element: <PrivateRoute component={PujaTable} />,
      },
      {
        path: "puja/add",
        element: <PrivateRoute component={AddPuja} />,
      },
      {
        path: "puja/edit/:id",
        element: <PrivateRoute component={EditPuja} />,
      },
      {
        path: "puja/view/:id",
        element: <PrivateRoute component={PujaView} />,
      },
      /** puja management route end */

      /** video management route start */
      {
        path: "video/list/:pgno",
        element: <PrivateRoute component={VideoTable} />,
      },
      {
        path: "video/add",
        element: <PrivateRoute component={AddVideo} />,
      },
      {
        path: "video/edit/:id",
        element: <PrivateRoute component={EditVideo} />,
      },
      {
        path: "video/view/:id",
        element: <PrivateRoute component={ViewVideo} />,
      },
      /** video management route end */

      /** Payment Management route start */
      {
        path: "payment-management/summary",
        element: <PrivateRoute component={PaymentSummary} />,
      },
      {
        path: "payment-management/wallet-history/:pgno",
        element: <PrivateRoute component={WalletHistory} />,
      },
      {
        path: "payment-management/gateway-payments/:pgno",
        element: <PrivateRoute component={GatewayPayments} />,
      },
      {
        path: "payment-management/order-payments/:pgno",
        element: <PrivateRoute component={OrderPayments} />,
      },
      {
        path: "payment-management/consultation-payments/:pgno",
        element: <PrivateRoute component={ConsultationPayments} />,
      },
      {
        path: "payment-management/view/:source/:id",
        element: <PrivateRoute component={TransactionView} />,
      },
      /** Payment Management route end */


      /** notification management route start */
      {
        path: "notification",
        element: <PrivateRoute component={NotificationTable} />,
      },
      {
        path: "notification/send",
        element: <PrivateRoute component={SendNotification} />,
      },
      {
        path: "notification/view/:id",
        element: <PrivateRoute component={ViewNotification} />,
      },
      {
        path: "notification/edit/:id",
        element: <PrivateRoute component={EditNotification} />,
      },
     
    ],
  },
  {
    path: "admin",
    element: <AdminUnAuthLayout />,
    children: [
      { path: "login", element: <PublicRoute component={Login} /> },
      {
        path: "forget-password",
        element: <PublicRoute component={ForgotPwdPage} />,
      },
      {
        path: "otp-verification/:email",
        element: <PublicRoute component={OtpVerificationPage} />,
      },
      {
        path: "reset-password",
        element: <PublicRoute component={ResetPwdPage} />,
      },
    ],
  },
  {
    path: "admin/complete-profile/:validate_string",
    element: <PublicRoute component={CompleteAdminProfile} />,
  },

  { path: "admin/*", element: <Error404 /> },
]);

export default router;
